import { writable, derived } from 'svelte/store';

export const storeName = writable();
export const frequency = writable();
export const next = writable();

export const filters = derived( [storeName, frequency, next], ([$storeName, $frequency, $next], set) => {
    set({storeName: $storeName, frequency: $frequency, next: $next});
});